angular.module 'app'
.controller 'ResponseLayoutCtrl', ($scope, $http, $stateParams, $state, config, Storage) ->

  $scope.permission = Storage.get('user_permission')
